import { lazy } from 'react'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

const TravelStatusViewChunk = lazy(() =>
  import('../feature-sets/TravelStatusView').then(({ TravelStatusView }) => ({
    default: TravelStatusView,
  }))
)

export const TravelStatusPage = () => {
  const intl = useProcurifyIntl()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.travelStatusPageTitle)}
      breadcrumbs={[
        {
          name: intl.formatMessage(messages.travelStatusPageTitle),
        },
      ]}
    >
      <TravelStatusViewChunk />
    </Page>
  )
}
